/* eslint-disable */
export default {
  start: 'Faça um tour rápido',
  skip: 'Pular',
  next: 'Avançar',
  finish: 'Finalizar',
} as const;

// @key: @#@"start"@#@ @source: @#@"Take a quick tour"@#@
// @key: @#@"skip"@#@ @source: @#@"Skip"@#@
// @key: @#@"next"@#@ @source: @#@"Next"@#@
// @key: @#@"finish"@#@ @source: @#@"Finish"@#@
